import { c as _c } from "react/compiler-runtime";
import React, { RefObject, useContext } from "react";
import Icon from "@/components/icon";
import { sidebarContext } from "@/context/sidebar-context";
import { LeadTransitionEnum } from "@/TS/Enums/global_enums";
import { CoordsProps, GetActionsOptionsProps, LeadRead, LeadTransition, TagColors } from "@/TS/Interfaces/global_interfaces";
import { LeadTransitionType } from "@/TS/Types/global_types";
import { isPresident } from "@/utils/global-utils";
export const GetActionsOptions = t0 => {
  const $ = _c(34);
  let CustomView;
  let allowedTransitions;
  let authorizedTransitionsEnum;
  let club;
  let myProfile;
  let onClick;
  let recipientIsUser;
  let rest;
  let senderIsUser;
  let slug;
  let status;
  if ($[0] !== t0) {
    const {
      CustomView: t1,
      onClick: t2,
      authorizedTransitionsEnum: t3,
      status: t4,
      slug: t5,
      setLeadsStats: _setLeadsStats,
      myProfile: t6,
      allowedTransitions: t7,
      recipientIsUser: t8,
      senderIsUser: t9,
      club: t10,
      ...t11
    } = t0;
    CustomView = t1;
    onClick = t2;
    authorizedTransitionsEnum = t3;
    status = t4;
    slug = t5;
    myProfile = t6;
    allowedTransitions = t7;
    recipientIsUser = t8;
    senderIsUser = t9;
    club = t10;
    rest = t11;
    $[0] = t0;
    $[1] = CustomView;
    $[2] = allowedTransitions;
    $[3] = authorizedTransitionsEnum;
    $[4] = club;
    $[5] = myProfile;
    $[6] = onClick;
    $[7] = recipientIsUser;
    $[8] = rest;
    $[9] = senderIsUser;
    $[10] = slug;
    $[11] = status;
  } else {
    CustomView = $[1];
    allowedTransitions = $[2];
    authorizedTransitionsEnum = $[3];
    club = $[4];
    myProfile = $[5];
    onClick = $[6];
    recipientIsUser = $[7];
    rest = $[8];
    senderIsUser = $[9];
    slug = $[10];
    status = $[11];
  }
  const {
    setVal
  } = useContext(sidebarContext);
  let t1;
  if ($[12] !== CustomView || $[13] !== allowedTransitions || $[14] !== club || $[15] !== myProfile || $[16] !== onClick || $[17] !== rest || $[18] !== setVal || $[19] !== slug || $[20] !== status) {
    t1 = transition => {
      if (onClick) {
        onClick();
        return;
      }
      setVal(<CustomView status={status} slug={slug} club={club} allowedTransitions={allowedTransitions} preTransition={transition} myProfile={myProfile} {...rest} />);
    };
    $[12] = CustomView;
    $[13] = allowedTransitions;
    $[14] = club;
    $[15] = myProfile;
    $[16] = onClick;
    $[17] = rest;
    $[18] = setVal;
    $[19] = slug;
    $[20] = status;
    $[21] = t1;
  } else {
    t1 = $[21];
  }
  const handleClickAction = t1;
  let t2;
  if ($[22] !== allowedTransitions || $[23] !== authorizedTransitionsEnum || $[24] !== club || $[25] !== handleClickAction || $[26] !== recipientIsUser || $[27] !== senderIsUser) {
    const getFilteredAllowedTransitions = allowedTransitions?.filter(transition_0 => {
      if (!authorizedTransitionsEnum) {
        return true;
      }
      return transition_0.toUpperCase() in authorizedTransitionsEnum;
    }) || [];
    let t3;
    if ($[29] !== club || $[30] !== handleClickAction || $[31] !== recipientIsUser || $[32] !== senderIsUser) {
      t3 = transition_1 => <label key={transition_1} onClick={() => handleClickAction(transition_1)} className="hover:bg-light-grey px-6 py-3 transition-all cursor-pointer has-[:checked]:bg-light-grey"><input className="hidden checked:bg-light-grey" type="radio" name="sort" />{getTransitionLabel(transition_1, senderIsUser, recipientIsUser, isPresident(club))}</label>;
      $[29] = club;
      $[30] = handleClickAction;
      $[31] = recipientIsUser;
      $[32] = senderIsUser;
      $[33] = t3;
    } else {
      t3 = $[33];
    }
    t2 = getFilteredAllowedTransitions.map(t3);
    $[22] = allowedTransitions;
    $[23] = authorizedTransitionsEnum;
    $[24] = club;
    $[25] = handleClickAction;
    $[26] = recipientIsUser;
    $[27] = senderIsUser;
    $[28] = t2;
  } else {
    t2 = $[28];
  }
  return t2;
};
export const getColor = (color?: TagColors): {
  bg: string;
  text: string;
} => {
  let colors: {
    bg: string;
    text: string;
  };
  switch (color) {
    case "traded":
    case "signed":
    case "sent":
      colors = {
        bg: "#CCECFC",
        text: "#009EF1"
      };
      break;
    case "accepted":
      colors = {
        bg: "#D3C9EB",
        text: "#9A7CDE"
      };
      break;
    case "cancelled":
      colors = {
        bg: "#E6E6E6",
        text: "#9B9B9B"
      };
      break;
    case "created":
    case "president_accepted":
    case "guest_accepted":
    case "present":
    case "transformed":
      colors = {
        bg: "#D0EEE4",
        text: "#14AB76"
      };
      break;
    case "transformedAmount":
      colors = {
        bg: "#CDE9F2",
        text: "#234653"
      };
      break;
    case "wait":
    case "pending_sign":
    case "received":
      colors = {
        bg: "#FCE8CC",
        text: "#F18A00"
      };
      break;
    case "president_refused":
    case "refused":
    case "absent":
    case "not_transformed":
    case "expired":
      colors = {
        bg: "#FCDAD9",
        text: "#FC4E49"
      };
      break;
    case "anonymized":
      colors = {
        bg: "#E6E6E6",
        text: "#666666"
      };
      break;
    default:
      colors = {
        bg: "#CDE9F2",
        text: "#234653"
      };
      break;
  }
  return colors;
};
export const getLabelPastelTag = (statut: string) => {
  switch (statut) {
    case "traded":
      return "Échangé";
    case "president_accepted":
      return "Acceptée";
    case "guest_accepted":
      return "Acceptée";
    case "accepted":
      return "Accepté";
    case "transformed":
      return "Transformé";
    case "cancelled":
      return "Annulé";
    case "not_transformed":
      return "Non transformé";
    case "received":
      return "Reçu";
    case "president_refused":
      return "Refusée";
    case "refused":
      return "Refusé";
    case "sent":
      return "Envoyé";
    case "wait":
      return "En attente";
    case "present":
      return "Présent(e)";
    case "absent":
      return "Absent(e)";
    case "created":
      return "Crée";
    case "signed":
      return "Contrat signé";
    case "pending_sign":
      return "En attente de signature";
    case "expired":
      return "Expiré";
  }
};
export const getTransitionLabel = (transition: string, senderIsUser?: boolean, recipientIsUser?: boolean, isPresident?: boolean): string | false | undefined => {
  switch (transition) {
    case "accept":
      return "Accepter";
    case "refuse":
      return "Refuser";
    case "cancel":
      return (senderIsUser || isPresident) && "Annuler le lead";
    case "transform":
      return "Transformer le lead";
    case "not_transform":
      return "Ne pas transformer le lead";
    case "modify":
      return "Modifier le lead";
  }
};
export const getTransformedTransition = (transition: LeadTransitionType, options?: {
  reasonForRefusal?: string;
}): LeadTransition | undefined => {
  switch (transition) {
    case LeadTransitionEnum.ACCEPT:
      return {
        transition: transition
      };
    case LeadTransitionEnum.REFUSE:
      return {
        transition: transition,
        ...(options?.reasonForRefusal ? {
          reasonForRefusal: options.reasonForRefusal
        } : {})
      };
    case LeadTransitionEnum.CANCEL:
      return {
        transition: transition
      };
    case LeadTransitionEnum.NOT_TRANSFORM:
      return {
        transition: transition
      };
  }
};
export const getLeadIcon = (colorTheme?: string) => {
  switch (colorTheme) {
    case "accept":
      return <Icon icon={"check-simple"}></Icon>;
    case "refuse":
      return <Icon icon={"cross"}></Icon>;
  }
};
function getPositionLeft(obj: HTMLElement) {
  var curleft = obj.offsetLeft;
  if (obj.offsetParent) {
    curleft = obj.offsetLeft;
    while (obj = obj.offsetParent as HTMLElement) {
      curleft += obj.offsetLeft;
    }
  }
  return curleft;
}
function getPositionTop(obj: HTMLElement) {
  var curleft = obj.offsetTop;
  if (obj.offsetParent) {
    curleft = obj.offsetTop;
    while (obj = obj.offsetParent as HTMLElement) {
      curleft += obj.offsetTop;
    }
  }
  return curleft;
}
export const calculateCoords = (setter: (coords: CoordsProps) => void, ref: RefObject<HTMLElement | null>, additionalX?: number, additionalY = 0) => {
  if (ref.current) {
    const coords = {
      offsetTop: getPositionTop(ref.current) + additionalY,
      offsetLeft: additionalX ? getPositionLeft(ref.current) - parseInt(String(ref.current.offsetParent?.clientWidth)) : getPositionLeft(ref.current),
      h: ref.current?.offsetHeight,
      w: ref.current?.offsetWidth
    };
    setter(coords);
  }
};
let executed = false;
export function scrollToTop<TElement extends HTMLElement>(scrollTop: number = 0, ref: Window | RefObject<TElement | null> = window, inputRef: any = null): void {
  if (executed) return;
  if (inputRef?.current.parentElement) {
    let offsetTop = inputRef.current.offsetTop;
    let parent: HTMLElement | null = inputRef.current.offsetParent as HTMLElement | null;
    while (parent && parent !== document.body) {
      offsetTop += parent.offsetTop;
      parent = parent.offsetParent as HTMLElement | null;
    }
    if ("current" in ref) {
      ref.current?.scrollTo({
        top: offsetTop + scrollTop - (inputRef.current.offsetHeight + 150),
        behavior: "smooth"
      });
    } else {
      ref.scrollTo({
        top: offsetTop + scrollTop - (inputRef.current.offsetHeight + 150),
        behavior: "smooth"
      });
    }
  } else {
    window.scrollTo({
      top: scrollTop,
      behavior: "smooth"
    });
  }
  executed = true;
  setTimeout(() => {
    executed = false;
  }, 1000);
}
export const getAuthorizedTransitions = (transition: string, lead: Pick<LeadRead, "senderIsUser" | "recipientIsUser">): boolean => {
  if (lead.senderIsUser) {
    const allowedList: string[] = [LeadTransitionEnum.CANCEL, LeadTransitionEnum.MODIFY];
    return allowedList.includes(transition);
  } else if (lead.recipientIsUser) {
    const allowedList: string[] = [LeadTransitionEnum.ACCEPT, LeadTransitionEnum.REFUSE, LeadTransitionEnum.TRANSFORM, LeadTransitionEnum.NOT_TRANSFORM];
    return allowedList.includes(transition);
  }
  return false;
};
export const getNameFromSenderOrRecipient = (person: {
  firstName?: string;
  lastName?: string;
} | null | undefined) => {
  if (person?.firstName || person?.lastName) {
    return person?.firstName + " " + person?.lastName;
  }
  return "-";
};